import type { PImage } from '../../engine/aliases'
import { assert } from '../../lib/assert-sidecar'
import { largeSprites } from '../../sprites/largeSprites'
import { spritesUtil } from '../../sprites/spritesUtil-sidecar'
import { chessLayers } from './chessLayers-sidecar'

export interface IChessBoard {
  image: PImage
}

let _obj: IChessBoard | null = null
export function get() {
  assert.notNil(_obj, 'tilemap not created')
  return _obj
}

export const spotSize = 32

export function create(): IChessBoard {
  let image = spritesUtil.createLargeSprite(
    chessLayers.getLayers().board,
    largeSprites.chessBoard,
  )

  image.scale = 0.5
  image.alpha = 0.25

  let obj: IChessBoard = {
    image,
  }
  _obj = obj
  return obj
}

export function update() {}
